import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { TCol, TRow } from "../../../../components/layout/listing-table/listing-table.types";

import { FlyerListTableProps } from "./flyer-list-table.props";
import { FlyerListCurrentHeader } from "../flyer-list-current-header/flyer-list-current-header.component";
import { buildColumns } from "../../types/flyer-list-table/flyer-list-table.functions";
import {
  completedHeaderRow,
  completedLabel,
} from "../../types/flyer-list-table/flyer-list-table.configuration";
import { getResourceLink } from "../../../../features/navigation/types/pages.functions";
import { BasicResourceType } from "../../../../types/resources/resources.enums";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { splitFlyersByCreatedDate } from "../../types/split-flyers/split-flyers.functions";

import Grid from "@material-ui/core/Grid";
import { FlyerListGridCard } from "../flyer-list-grid-card/flyer-list-grid-card.component";
import { ListingTableFlyer } from "./listing-table-flyer.component";
import { useGridStyles } from "../flyer-list-grid/flyer-list-grid.styles";

import * as store from "../../store/flyer.store";

export const FlyerListTable = withShowIf((props: FlyerListTableProps) => {
  const isGridView = useSelector(store.isGridView);
  const { currentList, completedList } = useMemo(() => splitFlyersByCreatedDate(props.dataList), [
    props.dataList,
  ]);

  const showCurrentGrid = () => Boolean(currentList.length) && isGridView;
  const showCurrentList = () => Boolean(currentList.length) && !isGridView;
  const showCompletedList = () => Boolean(completedList.length);

  const showCompletedHeader = () => showCurrentList() && showCompletedList();

  const dataList = useMemo(() => {
    return [
      ...(showCurrentList() ? currentList : []),
      ...(showCompletedHeader() ? completedHeaderRow : []),
      ...(showCompletedList() ? completedList : []),
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGridView, props.dataList]);

  const firstColumnHeader = useMemo((): Partial<TCol> => {
    if (showCurrentList()) {
      return { label: "" };
    }

    return { label: completedLabel };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGridView, dataList]);

  const getLink = (flyer: TRow) => getResourceLink(flyer.id, BasicResourceType.Flyer) ?? "";
  const classes = useGridStyles();

  return (
    <>
      <FlyerListCurrentHeader gridView={isGridView} setGridView={store.setGridView} />
      {showCurrentGrid() === true && (
        <div className={classes.grid}>
          <Grid container direction="row" alignItems="flex-start">
            {currentList.map((flyer) => (
              <FlyerListGridCard key={flyer.id} flyer={flyer} />
            ))}
          </Grid>
        </div>
      )}
      <ListingTableFlyer
        columns={buildColumns(firstColumnHeader)}
        dataList={dataList}
        link={getLink}
        showIf={dataList.length > 0}
        isListView={!isGridView}
      />
    </>
  );
});
